module.exports = __webpack_public_path__ + "img/宸山医疗.690ae34.png";